import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  pure: true
})
@Injectable()
export class OrderByPipe implements PipeTransform {

  transform(value: any, field: string): Array<any> {
    let newData;

    if (value) {
      newData = value.sort((a: any, b: any) => {
        return a.order < b.order ? 1 : -1;
      });

      console.log(newData)
      return newData;
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/order-by.ts